module.exports = __webpack_public_path__ + "media/images/athletes/1657-f3ee46d2136e3338c0addb21c0624aff.png";